import React, { useImperativeHandle, forwardRef, useState, useEffect, useRef, useCallback } from "react";
import AppSimpleBar from "components/AppSimpleBar";
import { Button, Collapse, Dropdown, DropdownItem, DropdownMenu } from "reactstrap";
import classnames from "classnames";
import styled from 'styled-components';
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";
import { Utils } from "helpers/utils";
import { bgcolor, maxHeight } from "@mui/system";
import TextBox from "components/TextBox";
import Loader from "components/Loader";
import { WorkPlaceFilterSel, WorkPlaceCatFilter, WorkPlaceTagFilter, WpSliceData, WpEmpFilterType } from "../../../redux/workplace/wpTypes";
import { Const } from "const";
import { debounce, last, set } from "lodash";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { FormControlLabel, Switch } from "@mui/material";
import Select, { components } from 'react-select';
import { EmployeeOrg } from "types";


interface WpCatItemProps {
  tagCat: WorkPlaceCatFilter;
  // category: string;
  // tags: WorkPlaceTagFilter[] | null;
  item: any;
  // onTagClick: (tagId: number, isFromSearch: boolean, icon: string, color: string, bgColor: string) => void;
  onTagSelect: (cat: string, tagSelected: WorkPlaceFilterSel[]) => void;
  onSearchTag: (cat: string, filter: string) => void;
  onClickTag: (cat: string, tagId: number, tagName: string) => void;
  onClickMuliSel: (cat: string) => void;
  onClickMatchedAll: (cat: string, matchedAll: boolean) => void;
  onClickOption: (cat: string, type: string, value: any) => void;
  onToggleCollapse: (cat: string, collapseAll: boolean | null) => void;
  tagFilter: string;
  // onTagDel: (tagId: number) => void;
  // icon: string;
}

const WpCatItem = ({ tagCat, onSearchTag, onClickTag, onClickMuliSel, onClickMatchedAll, item, onTagSelect, tagFilter, onClickOption, onToggleCollapse }: WpCatItemProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      tagFilterSelected: wp.tagFilterSelected,
    })
  );
  const { tagFilterSelected } = useAppSelector(storeData);


  // const [isOpen, setIsOpen] = useState<boolean>(true);
  const isOpen = !tagCat.isCollapse;
  const [filter, setFilter] = useState<string>("");
  const toggleCollapse = () => {
    // setIsOpen((prev) => !prev);
    onToggleCollapse(tagCat.category, null);
  };

  const onSearchTagIn = () => {
    onSearchTag(tagCat.category, filter);
  }

  useEffect(() => {
    // console.log('WpCatItem - Render');
  }, []);

  const tagCount = (tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter)).length;
  const visible = tagFilter === "" || tagCount > 0;

  return (
    <div className="workplace-filter-cat" style={{ display: visible ? "" : "none" }} >
      <div className="d-flex justify-content-between workplace-filter-cat-head text-primary"  >
        <div className="d-flex justify-content-between align-items-center " style={{ flex: "1" }}>
          <i
            className={classnames("fab fa-blackberry me-2 hand", { "text-secondary": !tagCat.isMultiSel, "text-red": tagCat.isMultiSel })}
            onClick={(e) => onClickMuliSel(tagCat.category)}
          ></i>
          <span style={{ flex: "1",/*width: "100%"*/ }} className="hand " onClick={toggleCollapse}>
            <i className={classnames("", "me-1", item.faIcon)} ></i>
            {item.name}
          </span>
        </div>
        <div className="hand me-2" >
          {/* <input id="chkMulti" type="checkbox"></input><label htmlFor="chkMulti">multi</label> */}
          {/* <i className={classnames("fas fa-check-double", { "text-secondary": !tagCat.isMatchedAll, "text-red": tagCat.isMatchedAll })}
            onClick={(e) => onClickMatchedAll(tagCat.category)}
          ></i> */}
          {/* <select className={classnames("wp-ddl-or-and text-primary", { "text-primary": !tagCat.tagMatchedAll , "text-warning": tagCat.tagMatchedAll })}
            value={tagCat.tagMatchedAll ? "1" : "0"} onChange={(e) => onClickMatchedAll(tagCat.category, e.target.value)}>
            <option value="0">OR</option>
            <option value="1">AND</option>
          </select> */}

          <span
            className={classnames("badge hand " + (tagCat.tagMatchedAll ? " badge-primary text-danger " : " badge-warning text-primary "), {})}
            onClick={(e) => onClickMatchedAll(tagCat.category, !tagCat.tagMatchedAll)}
          >
            {tagCat.tagMatchedAll ? "AND" : "OR"}
          </span>


          {/* <FormControlLabel
            control={
              <Switch checked={tagCat.tagMatchedAll}
                color={tagCat.tagMatchedAll ? "warning" : "primary"}
                onChange={(e) => { onClickMatchedAll(tagCat.category, e.target.value ? "1" : "0")}}
              />}
            label={tagCat.tagMatchedAll ? "AND" : "OR"} /> */}

          &nbsp;&nbsp;&nbsp;
          <i onClick={toggleCollapse} className={classnames("pt-1", { "fas fa-angle-up": isOpen, "fas fa-angle-down": !isOpen })}></i>
        </div>
      </div>
      <Collapse
        isOpen={isOpen}
        className="accordion-collapse"
      >
        <div style={{ position: "relative" }}>
          {tagCat.isSearching && (<Loader />)}
          {tagCat.category === Const.WP_CAT_EMP && (
            <div className="ps-2 d-flex" style={{ gap: "5px" }}>
              {/* <input id={`chkEmpIncludePostRelated`} type="checkbox" checked={tagCat.empIncludePostRelated ?? false}
                onChange={(e) => onClickOption(tagCat.category, "chkEmpIncludePostRelated", e.target.checked)}
              ></input>
              &nbsp;<label htmlFor="chkEmpIncludePostRelated">รวมโพสที่ถูก tag</label> */}
              <div className="hand">
                <input type="radio" name="WpEmpFilterType" id="WpEmpFilterType1" checked={tagCat.empFilterType === WpEmpFilterType.Poster}
                  onChange={(e) => onClickOption(tagCat.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Poster} />
                <label htmlFor="WpEmpFilterType1">ผู้โพส</label>
              </div>
              <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
                <input type="radio" name="WpEmpFilterType" id="WpEmpFilterType2" checked={tagCat.empFilterType === WpEmpFilterType.Tagged}
                  onChange={(e) => onClickOption(tagCat.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Tagged} />
                <label htmlFor="WpEmpFilterType2">ถูก tag</label>
              </div>
              <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
                <input type="radio" name="WpEmpFilterType" id="WpEmpFilterType3" checked={tagCat.empFilterType === WpEmpFilterType.InPost}
                  onChange={(e) => onClickOption(tagCat.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.InPost} />
                <label htmlFor="WpEmpFilterType3">เกี่ยวข้อง</label>
              </div>
            </div>
          )}
          {/* 20250612 hide textbox inside each category because use global filter instead */}
          {/* {tagCat.showSearchBox && (
            <div className="ms-1 me-2">
              <TextBox placeholder="ค้นหา" icon13css="fas fa-search" icon13small={true} style={{ padding: "2px" }} value={filter} onChange={(e) => setFilter(e.target.value)} onEnter13={onSearchTagIn} />
            </div>
          )} */}
          <AppSimpleBar style={{ maxHeight: "200px" }}>
            <div className="ps-2 pt-1 pb-2">
              {/* all tag from database */}
              {(tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter)).map((tag: any, index: number) => {
                const sel = (tagFilterSelected ?? []).some(t => t.tagId === tag.tagId);
                return (
                  (
                    <span key={tag.tagId}
                      className={classnames("wp-tag-filter hand mb-2 hover", { "wp-tag-filter-sel": sel/*tag.selected*/ })}
                      onClick={() => onClickTag(tagCat.category, tag.tagId, tag.tagName)}
                      data-tg={`${tag.tagId}.${tag.tagKeyId}`}
                    >
                      <i className={"text-primary"}></i> {tag.name}
                    </span>
                  )
                )
              })}
            </div>
          </AppSimpleBar>
        </div>
      </Collapse>
    </div>
  );
};

interface WorkPlaceFilterProps {
  onApplyFilter: () => void;
  allTags: WorkPlaceCatFilter[];
  onTagSelect: (cat: string, tagSelected: WorkPlaceFilterSel[]) => void;
  onSearchTag: (cat: string, filter: string) => void;
  onClickTag: (cat: string, tagId: number, tagName: string) => void;
  onClickMuliSel: (cat: string) => void;
  onClickMatchedAll: (cat: string, matchedAll: boolean) => void;
  filterUnRead: boolean;
  onFilterUnRead: (value: boolean) => void;
  filterNotClose: boolean;
  onFilterNotClose: (value: boolean) => void;
  onClickOption: (cat: string, type: string, value: any) => void;
  onToggleCollapse: (cat: string, collapseAll: boolean | null) => void;
}



const WorkPlaceFilter = ({ onApplyFilter, onSearchTag, onClickTag, onTagSelect, onClickMuliSel, onClickMatchedAll, allTags, filterUnRead, onFilterUnRead, filterNotClose, onFilterNotClose, onClickOption, onToggleCollapse }: WorkPlaceFilterProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      tagFilterSelected: wp.tagFilterSelected,
    })
  );
  const { tagFilterSelected } = useAppSelector(storeData);

  const [tagFilter, setTagFilter] = useState<string>("");
  const showCollapseAll = allTags.findIndex(prev => !prev.isCollapse) !== -1;
  const catShowSearch = allTags.filter(catx => catx.showSearchBox).map(x => x.category);
  const catShowSearchRef = useRef(catShowSearch);
  const delay = Utils.IsDesktop() ? 700 : 1500;

  useEffect(() => { catShowSearchRef.current = catShowSearch; }, [catShowSearch]);

  useEffect(() => {
    onMainFilterChangeDoSearch(tagFilter);
  }, [tagFilter]);

  const onMainFilterChangeDoSearch = useCallback(
    debounce((tagFilterDbc) => {
      catShowSearchRef.current.forEach(x => onSearchTag(x, tagFilterDbc));
      // console.log('onMainFilterChangeDoSearch with filter = ' + tagFilterDbc);
    }, delay),
    [] // Dependencies are empty so it's only created once
  );

  const [filterMode, setFilterMode] = useState<"tag" | "emp">("tag");
  const [employeeOrg, setEmployeeOrg] = useState<EmployeeOrg[]>([]);
  const [ddlDivisionValues, setDdlDivisionValues] = useState<string[]>([]);
  const [ddlDepartmentValues, setDdlDepartmentValues] = useState<string[]>([]);
  const [empFilter, setEmpFilter] = useState<string>("");
  useEffect(() => {
    if (employeeOrg.length <= 0 && filterMode == "emp") {
      const api = new APIClient();
      api.fnPostForm(urls.LOAD_EMPLOYEE_ORG, {})
        .then(rs => setEmployeeOrg(rs))
        .catch(ex2 => Utils.HandleException(ex2, true));
    }
  }, [filterMode]);
  const ddlDivision = Array.from(
    new Map(
      employeeOrg
        .filter(ee => ee.divisionName)
        .map(t => [t.divisionName, { label: t.divisionName, value: t.divisionName }])
    ).values()
  ).sort((a: any, b: any) => a.label.localeCompare(b.label));
  // useEffect(() => { console.log('ddlDivisionValues:', ddlDivisionValues); }, [ddlDivisionValues])
  const ddlDepartments = Array.from(
    new Map(
      employeeOrg
        .filter(ee =>
          ee.departmentName !== ""
          && (ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName))
          // && (() => { return ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName); })()
        ).map(t => [t.departmentName, { label: t.departmentName, value: t.departmentName }])
    ).values()
  ).sort((a: any, b: any) => a.label.localeCompare(b.label));

  const ddlEmployees = Array.from(
    new Map(
      employeeOrg
        .filter(ee =>
          ee.displayName2
          && (ddlDivisionValues.length <= 0 || ddlDivisionValues.includes(ee.divisionName))
          && (ddlDepartmentValues.length <= 0 || ddlDepartmentValues.includes(ee.departmentName))
          && (empFilter === "" || Utils.IsMatchAny(ee.displayName2, empFilter))
        ).map(t => [t.displayName2, { ...t }])
    ).values()
  ).sort((a: any, b: any) => a.displayName2.localeCompare(b.displayName2));

  // useEffect(() => { console.log('ddlDivision:', ddlDivision); }, [ddlDivision]);
  // useEffect(() => { console.log('ddlDepartments:', ddlDepartments); }, [ddlDepartments]);
  // useEffect(() => { console.log('ddlEmployees:', ddlEmployees); }, [ddlEmployees]);

  // useEffect(() => { console.log('employeeOrg:', employeeOrg); }, [employeeOrg]);

  const tagCatEmp: WorkPlaceCatFilter = allTags.find(t => t.category === Const.WP_CAT_EMP) ?? {
    category: "",
    faIcon: "",
    faColor: "",
    name: "",
    bgColor: "",
    tagCount: 0,
    showSearchBox: false,
    isSearching: null,
    isMultiSel: null,
    tagMatchedAll: false,
    empFilterType: WpEmpFilterType.Poster,
    tags: null,
    isCollapse: false,
  };

  return (
    <div className="work-place-filter">
      <div className="work-place-filter-head m-1 mb-2 ">
        <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          {/* <h5 style={{ flex: "1", margin: "0px" }}>Filter</h5>
          <i className='fas fa-angle-double-left hand fz-15' onClick={onApplyFilter}></i>
          &nbsp; */}

          <div style={{ display: "flex", alignItems: "center", flex: 1 }} className="">
            {/* <h5 style={{ margin: "0px", marginRight: "8px" }}>Filter</h5> */}
            <div className="d-flex justify-content-between" style={{ marginRight: "10px", flex: 1 }}>
              <input
                type="text"
                placeholder="กรอง tag..."
                className="work-place-filter-text form-control form-control-inline"
                value={tagFilter}
                onChange={(e) => setTagFilter(e.target.value)}
                style={{ width: "100%" }}
                onFocus={(e) => setFilterMode("tag")}

              />
              {tagFilter && (<i className="fa fa-close fz-14 mt-1 hand" onClick={() => setTagFilter("")}></i>)}
            </div>
            <div className="">
              <button
                className={classnames("wp-btn-filter-emp", { "bg-warning": filterMode == "emp" })}
                title="กรองพนักงาน แบบเลือกจากโครงสร้างองค์กร"
                onClick={() => setFilterMode(filterMode === "emp" ? "tag" : "emp")}
              >
                <i className="fa fa-filter"></i>
                พนักงาน
              </button>
            </div>

          </div>
          <i
            className="fas fa-angle-double-left hand fz-15 ms-1"
            onClick={onApplyFilter}
          ></i>
        </div>
      </div>
      <div id="tagFilterByTag" className={classnames("", { "hide": filterMode !== "tag" })}>
        <div className="ps-2 " style={{ backgroundColor: "var(--bs-body-bg)" }}>
          <div className="d-flex justify-content-between align-items-center">
            {/* left */}
            <div>
              <input type="checkbox" id="chkFilterUnread" checked={filterUnRead} onChange={(e) => onFilterUnRead(e.target.checked)} />&nbsp;<label htmlFor="chkFilterUnread">ยังไม่อ่าน</label>
              &nbsp;
              <input type="checkbox" id="chkFilterIsOpen" checked={filterNotClose} onChange={(e) => onFilterNotClose(e.target.checked)} />&nbsp;<label htmlFor="chkFilterIsOpen">ยังไม่ปิด</label>
            </div>
            {/* right */}
            <div>
              <div className="text-center hand text-primary mt-1 mb-1"
                style={{ width: "28px" }} onClick={(e) => onToggleCollapse("", showCollapseAll)}>
                <i style={{}} className={classnames("fz-15 fas", { "fa-angle-double-up": showCollapseAll, "fa-angle-double-down": !showCollapseAll })}
                ></i>
              </div>
            </div>

          </div>
        </div>
        <AppSimpleBar className="work-place-filter-list ">
          <div id="wpTagCat" className="accordion-del accordion-flush-del">
            {allTags.map((data: WorkPlaceCatFilter, index: number) => (
              <WpCatItem
                key={data.category} tagCat={data} item={data} onSearchTag={onSearchTag} onClickMuliSel={onClickMuliSel} onClickMatchedAll={onClickMatchedAll}
                onClickTag={onClickTag} onTagSelect={onTagSelect} tagFilter={tagFilter} onClickOption={onClickOption} onToggleCollapse={onToggleCollapse}
              />
            ))}
          </div>
        </AppSimpleBar>
      </div>
      <div id="tagFilterByEmp" className={classnames("", { "hide": filterMode !== "emp" })} style={{ backgroundColor: "var(--bs-body-bg)", height: "100vh" }}>
        <div className="ps-0" >
          <div className="ps-2 d-flex" style={{ gap: "5px" }}>
            {/* <input id={`chkEmpIncludePostRelated`} type="checkbox" checked={tagCat.empIncludePostRelated ?? false}
                onChange={(e) => onClickOption(tagCat.category, "chkEmpIncludePostRelated", e.target.checked)}
              ></input>
              &nbsp;<label htmlFor="chkEmpIncludePostRelated">รวมโพสที่ถูก tag</label> */}
            <div className="hand">
              <input type="radio" name="WpEmpFilterType2" id="WpEmpFilterType21" checked={tagCatEmp.empFilterType === WpEmpFilterType.Poster}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Poster} />
              <label htmlFor="WpEmpFilterType21">ผู้โพส</label>
            </div>
            <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
              <input type="radio" name="WpEmpFilterType2" id="WpEmpFilterType22" checked={tagCatEmp.empFilterType === WpEmpFilterType.Tagged}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.Tagged} />
              <label htmlFor="WpEmpFilterType22">ถูก tag</label>
            </div>
            <div className="hand" title="ตัวเลือกนี้ ใช้ได้กับพนักงานในสายงาน/ติดตาม">
              <input type="radio" name="WpEmpFilterType2" id="WpEmpFilterType23" checked={tagCatEmp.empFilterType === WpEmpFilterType.InPost}
                onChange={(e) => onClickOption(tagCatEmp.category, "WpEmpFilterType", e.target.value)} value={WpEmpFilterType.InPost} />
              <label htmlFor="WpEmpFilterType23">เกี่ยวข้อง</label>
            </div>
          </div>

          <Select
            placeholder="เลือกหน่วยงาน"
            options={ddlDivision as any[]}
            styles={Utils.GetThemeForReactSelect()}
            // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
            onChange={(e: any) => setDdlDivisionValues(e ? [e.value] : [])}
            // value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
            isClearable={true}
          // isMulti={true}
          ></Select>

          <Select
            placeholder="เลือกแผนก"
            options={ddlDepartments as any[]}
            styles={Utils.GetThemeForReactSelect()}
            // onChange={(e: any) => setPermData(prev => prev.map(p2 => (p2.uid !== item.uid) ? p2 : { ...p2, division: e?.value }))}
            onChange={(e: any) => setDdlDepartmentValues(e ? [e.value] : [])}
            // value={item.division ? ddlDivison?.find(t => t.value === item.division) : null}
            isClearable={true}
          // isMulti={true}
          ></Select>

          <TextBox placeholder="กรองพนักงาน" className="form-control wp-filter-emp-textbox" value={empFilter} onChange={(e) => setEmpFilter(e.target.value)} />

          <AppSimpleBar className="wp-filter-emp-ctn">
            {ddlEmployees.map((x, index) => {
              const sel = tagFilterSelected.some(t => t.tagId === x.tagId);
              return (
                <div key={index}
                  className={classnames("hover hand", {
                    "bg-primary": sel,
                    "text-warning": sel
                  })}

                  onClick={() => onClickTag(Const.WP_CAT_EMP_FROM_BROWSE, x.tagId ?? -1, x.displayName2)}
                >
                  {x.displayName2}
                </div>
              )
            })}
          </AppSimpleBar>
        </div>
      </div>
    </div>
  );
};

export default WorkPlaceFilter;